import { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Lojas } from '../../sdk/@types/Restaurantes';
import LojaService from '../../sdk/services/Loja.service';

export default function useTerminalEmissorServico() {
  const access_token = localStorage.getItem('accessToken');
  const params = useParams<{ id: string }>();
  const [terminalEmissorServico, setTerminalEmissorServico] = useState<Lojas.TerminalTratado>();

  const fetchterminalEmissorServico = useCallback((terminalId: string) => {
    LojaService.getTerminalServicoById(terminalId)
      .then(trataDadosTerminal)
      .then(setTerminalEmissorServico);
  }, []);

  function trataDadosTerminal(dados: Lojas.TerminalTratado): Lojas.TerminalTratado {
    return dados;
  }

  return {
    terminalEmissorServico,
    fetchterminalEmissorServico,
  };
}
